import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import PowerSolution from "./PowerSolutions";
import SolutionHero from "./SolutionHero";
import SolutionsComponent from "./SolutionsComponent";

const SolutionsPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full bg-white min-h-screen">
      <Navbar />
      <SolutionHero />
      <SolutionsComponent />
      <PowerSolution />
      <Footer />
    </div>
  );
};

export default SolutionsPage;